define('modules/lp_info/views/variant_chart',['require','exports','module','base/layout','./variant_history_chart','./variant_funnel_chart','ldsh!../templates/variant_chart'],function (require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    VariantHistoryChart = require('./variant_history_chart'),
    VariantFunnelChart = require('./variant_funnel_chart');

  module.exports = Layout.extend({
    template: require('ldsh!../templates/variant_chart'),

    regions: {
      chart: '.js-chart',
    },

    initialize: function (options) {
      this.collection = options.collection;
      this.listenTo(this.collection, 'add', this.render);
    },

    helpers: function () {
      // we can't listen the event when user click on the option already selected
      // this way, we can't use this.model to render the view
      return {
        funnelOptions: this._getFunnelOptions(),
        // hide tabs when we have only content and confirmation
        hideTabs: this._getFunnelSize() <= 2,
      };
    },

    _getFunnelOptions: function () {
      return this.collection.map(function (item, idx) {
        return {
          key: idx,
          value: item.get('name'),
        };
      });
    },

    _getFunnelSize: function () {
      var mainVariant = this.collection.at(0);
      return mainVariant ? _.size(mainVariant.get('step_stats')) : 0;
    },

    onRender: function () {
      this._ensureChart();
      this.$el.i18n();
    },

    // tabs

    _getCurrentTab: function () {
      return this.$('.is-active').data('tab');
    },

    _setTab: function (tab) {
      this.$('[data-tab]').removeClass('is-active');
      this.$('[data-tab="' + tab + '"]').addClass('is-active');
    },

    // select

    _getSelectValue: function () {
      return parseInt(this.$('.js-select').val(), 10);
    },

    // chart

    _previousChartData: {},

    _ensureChart: function () {
      var _previousChartData = this._previousChartData,
        currentTab = this._getCurrentTab(),
        currentFunnel = this._getSelectValue(),
        View;
      if (_previousChartData.tab !== currentTab || _previousChartData.funnel !== currentFunnel) {
        _previousChartData.tab = currentTab;
        _previousChartData.funnel = currentFunnel;
        View = currentTab === 'history' ? VariantHistoryChart : VariantFunnelChart;
        this.regions.chart.show(
          new View({
            collection: this.collection,
            funnelIdx: currentFunnel,
          })
        );
      }
    },

    // DOM events

    events: {
      'click [data-tab]': '_onClickTab',
      'change .js-select': '_onChangeSelect',
    },

    _onClickTab: function (ev) {
      this._setTab($(ev.currentTarget).data('tab'));
      this._ensureChart();
    },

    _onChangeSelect: function (ev) {
      this._ensureChart();
    },
  });
});

